import React from 'react'
import { IKlant } from '../../../shared/models/IKlant'

interface IProps {
  customer: IKlant
}

export default (props: IProps) => {
  return (
    !!props.customer && (
      <table className='table'>
        <thead>
          <tr className='tablesubheader'>
            <th colSpan={3}>Klant</th>
          </tr>
        </thead>
        <tbody>
          <tr className='tablesubheader'>
            <td>Klantnummer</td>
            <td>Naam</td>
            <td>EAN</td>
          </tr>
          <tr>
            <td>{props.customer.klantNummer}</td>
            <td>{props.customer.klantNaam}</td>
            <td>{props.customer.klantEanCode}</td>
          </tr>
        </tbody>
      </table>
    )
  )
}
